<template>
  <div class="modal fade" id="modalChurn" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 v-if="typeModal === 1" class="title-modal">Churn.</h4>
          <h4 v-if="typeModal === 2" class="title-modal">Inadimplência.</h4>
        </div>

        <div v-if="typeModal === 1" class="modal-body">
          <form>
            <div class="form-group">
              <label>Tipo do motivo</label>
              <select name="selectMotive" id="selectMotive" v-model="dataChurn.typeMotive" class="form-control">
                <option value="">Selecione um tipo de motivo</option>
                <option v-for="(value, index) in $route.params.typesMotive" :value="value.id" :key="index">
                  {{ value.name }}
                </option>
              </select>
              <span v-if="error.typeMotive" class="error-msg">{{
                  error.typeMotive
                }}</span>
            </div>

            <div class="form-group">
              <label>Motivo do churn?</label>
              <input v-model="dataChurn.motive" type="text" class="form-control" name="motive" required/>
            </div>

            <div class="form-group">
              <label>Data do churn</label>
              <input v-model="dataChurn.dt" v-mask="'##/##/####'" type="text" class="form-control" name="dt" required/>
              <span v-if="error.dt" class="error-msg">{{ error.dt }}</span>
            </div>

            <div class="form-group">
              <label>Valor mensal R$?</label>
              <input v-model="dataChurn.value" v-mask="'########'" type="text" class="form-control" name="value"
                     required/>
              <span v-if="error.value" class="error-msg">{{
                  error.value
                }}</span>
            </div>
          </form>
        </div>

        <div v-if="typeModal === 1" class="modal-footer">
          <button v-on:click="sendChurn()" :disabled="loadingChange" v-bind:class="{ disable: loadingChange }"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Enviar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>

        <div v-if="typeModal === 2" class="modal-body">
          <form>
            <div class="form-group">
              <label>Observação</label>
              <input v-model="data2.motive" type="text" class="form-control" name="motive" required/>
              <span v-if="error.motive" class="error-msg">{{
                  error.motive
                }}</span>
            </div>
            <div class="form-group">
              <label>Senha</label>
              <input v-model="data2.password" type="password" class="form-control" name="password" required/>
              <span v-if="error.password" class="error-msg">{{
                  error.password
                }}</span>
            </div>
          </form>
        </div>

        <div v-if="typeModal === 2" class="modal-footer">
          <button v-on:click="sendInadimplencia()" :disabled="loadingChange" v-bind:class="{ disable: loadingChange }"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Enviar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ADD_CHURN,
  ADD_INADIMPLENCIA
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

export default {
  name: "modalMotiveChurn",
  props: ["dataCompanyModal"],
  data() {
    return {
      typeModal: null,
      companyId: "",
      context: "",
      error: {
        typeMotive: "",
        value: "",
        dt: "",
        motive: "",
        password: "",
      },
      dataChurn: {
        typeMotive: "",
        motive: "",
        value: "",
        dt: "",
      },
      data2: {
        motive: "",
        password: "",
      },
      loadingChange: false,
    };
  },
  watch: {
    dataCompanyModal: function (val) {
      this.companyId = val.id;
      this.context = val.context;
      this.typeModal = val.type;
    },
  },
  methods: {
    closeModal() {
      $("#modalChurn").modal("toggle");
    },
    sendChurn() {
      this.error.typeMotive = "";
      this.error.value = "";
      this.error.dt = "";

      if (
        this.dataChurn.typeMotive &&
        this.dataChurn.value &&
        this.dataChurn.dt &&
        this.companyId
      ) {
        let dateInverse = this.dataChurn.dt.split("/").reverse().join("-");
        this.loadingChange = true;
        UTIL_SERVICE.console("DATA SEND:", this.dataChurn);
        let urlModal =
          ADD_CHURN +
          "?i=" +
          this.companyId +
          "&churnCategoryId=" +
          this.dataChurn.typeMotive +
          "&value=" +
          this.dataChurn.value +
          "&dt=" +
          dateInverse;

        if (this.dataChurn.motive === "") {
          urlModal = urlModal + "&motive=" + "Vazio";
        } else {
          urlModal = urlModal + "&motive=" + this.dataChurn.motive;
        }
        REQUEST_SERVICE.requestContext("GET", urlModal, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT ADD_CHURN:", response);

            this.loadingChange = false;
            $("#modalChurn").modal("toggle");

            ALERT_SERVICE.swal(
              "Aviso",
              "Churn enviado com sucesso.",
              "success"
            );
          })
          .catch((reason) => {
            this.loadingChange = false;
            $("#modalChurn").modal("toggle");

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
      } else {
        if (!this.dataChurn.typeMotive) this.error.typeMotive = "Preencha algum tipo de motivo.";

        if (!this.dataChurn.value) this.error.value = "Preencha um valor.";

        if (!this.dataChurn.dt) this.error.dt = "Preencha uma data.";

        if (!this.companyId) {
          this.error.value = "CompanyID Inválido.";
          this.error.typeMotive = "CompanyID Inválido.";
          this.error.dt = "CompanyID Inválido.";
        }
      }
    },
    sendInadimplencia() {
      this.error.motive = "";
      this.error.value = "";
      this.error.password = "";

      if (this.companyId && this.data2.password) {
        this.loadingChange = true;
        UTIL_SERVICE.console("DATA SEND:", this.data2);
        let urlModal = ADD_INADIMPLENCIA + "?i=" + this.companyId;

        if (this.data2.motive) {
          urlModal += "&motive=" + this.data2.motive;
        }
        urlModal += "&pw=" + this.data2.password;

        REQUEST_SERVICE.requestContext("GET", urlModal, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT ADD_INADIMPLENCIA:", response);

            this.loadingChange = false;
            $("#modalChurn").modal("toggle");
            this.data2.password = "";

            ALERT_SERVICE.swal(
              "Aviso",
              "Inadimplência alterada com sucesso.",
              "success"
            );
          })
          .catch((reason) => {
            this.loadingChange = false;
            $("#modalChurn").modal("toggle");

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
      } else {
        if (!this.data2.password) this.error.password = "Senha é obrigatória.";

        if (!this.companyId) {
          this.error.motive = "CompanyID Inválido.";
        }
      }
    },
  },
};
</script>

<style lang="scss">
#modalChurn {
  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChurn.vue